import styled from "@emotion/styled";
import FlexCenter from "shared/components/Layout/components/FlexCenter";

export const StyledAppLoaderLogoWrapper = styled(FlexCenter)`
  width: 220px;
  height: 58px;
  margin: 0 auto;
  height: 100vh;

  img {
    width: 100%;
    height: 100%;
  }

  @keyframes logo {
    0% {
      transform: scale(2);
      filter: blur(10px);
      opacity: 0;
    }

    100% {
      transform: scale(1);
      filter: blur(0);
      opacity: 1;
    }
  }

  @keyframes heartbeat {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.5);
    }

    100% {
      transform: scale(1);
    }
  }

  animation:
    logo 2s ease-in 1 backwards,
    heartbeat 2s infinite 2s ease-out backwards;
`;
